import { auth } from '@/firebase';
import { useBusiness } from '@/hook/useBusiness';
import { useUsers } from '@/hook/useUsers';
import { LoginService } from '@/services/LoginService';
import { signInWithEmailAndPassword, getAuth, setPersistence, browserSessionPersistence } from 'firebase/auth';
import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import React from 'react';
interface accessTokenData {
  userId: number;
  token: string;
}


interface IAuthContextData {
  logout: () => void;
  isAuthenticated: boolean;
  login: (email: string, password: string) => Promise<Error | void>;
  isOwner: (userId: number) => boolean;
  accessToken: accessTokenData | undefined;
}

const AuthContext = createContext({} as IAuthContextData);

const LOCAL_STORAGE_KEY__ACCESS_TOKEN = 'APP_ACCESS_TOKEN';

interface IAuthProviderProps {
  children: React.ReactNode;
}

// eslint-disable-next-line react/prop-types
export const AuthProvider: React.FC<IAuthProviderProps> = ({ children }) => {
  const [accessToken, setAccessToken] = useState<{
    userId: number,
    token: string
  }>();
  const { fetchBusiness } = useBusiness();

  const auth = getAuth();

  const handleLogin = useCallback(
    async (email: string, password: string) => {
      try {
        // 1. Backend login
        const result = await LoginService.auth(email);
        if (!result) {
          throw new Error('Erro ao autenticar: Falha na conexão com banco de dados.');
        }

        const { userId, access_token, companyId } = result;

        await setPersistence(auth, browserSessionPersistence).then(() => {
          return signInWithEmailAndPassword(auth, email, password);
        }
        )
        // 4. Armazenar tokens e expiração no localStorage
        localStorage.setItem(LOCAL_STORAGE_KEY__ACCESS_TOKEN, JSON.stringify({
          userId,
          token: access_token
        }));
        localStorage.setItem('companyId', companyId.toString());

        setAccessToken({ userId, token: access_token });

        // fetchBusiness(companyId);
      } catch (error) {
        return error instanceof Error ? error : new Error('Erro ao autenticar');
      }
    },
    [fetchBusiness]
  );


  const handleLogout = useCallback(() => {
    localStorage.removeItem(LOCAL_STORAGE_KEY__ACCESS_TOKEN);
    setAccessToken(undefined);
  }, []);

  const isAuthenticated = useMemo(() => !!accessToken, [accessToken]);

  const isOwner = (userIdLogged: number) => accessToken ? accessToken!.userId == userIdLogged : false;

  return (
    <AuthContext.Provider value={{ isAuthenticated, accessToken, isOwner, login: handleLogin, logout: handleLogout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuthContext = () => useContext(AuthContext);
